// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var EnrollmentEligibility;
(function (EnrollmentEligibility) {
    EnrollmentEligibility[EnrollmentEligibility["Undetermined"] = 0] = "Undetermined";
    EnrollmentEligibility[EnrollmentEligibility["Passed"] = 1] = "Passed";
    EnrollmentEligibility[EnrollmentEligibility["Failed"] = 2] = "Failed";
})(EnrollmentEligibility || (EnrollmentEligibility = {}));
//# sourceMappingURL=enrollmentEligibility.js.map